import { makeRemoteAccountEnrollments } from '@/main/factories/usecases/account/remote-account-enrollment-factory'
import BaseLoader from '../loaders/base-loader'
import { QueryClient } from 'react-query'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { Account } from '@/domain/usecases'
import { RemoteAccountEnrollments } from '@/data/usecases/account/remote-account-enrollments'

export default class UserEnrollmentsLoader extends BaseLoader {
  private remoteAccountEnrollments

  constructor(
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined,
    readonly account: Account.Model
  ) {
    super(account, undefined, queryClient)
    this.remoteAccountEnrollments = makeRemoteAccountEnrollments(this.queryClient)
  }

  async loader() {
    const enrollments = await this.getEnrollments()

    return this.deferExec(enrollments)
  }

  async getEnrollments(): Promise<RemoteAccountEnrollments.Model> {
    const enrollments =
      (await this.remoteAccountEnrollments.loader()) as RemoteAccountEnrollments.Model
    return enrollments
  }
}
